import { render } from "./NotificationsEditComponent.vue?vue&type=template&id=303e81e6"
import script from "./NotificationsEditComponent.vue?vue&type=script&lang=js"
export * from "./NotificationsEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__